module.exports = "/desktop-app/assets/img/favicon.png?bdb5eb66af417f72ccf3c71f3ac999fc";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/static/img/favicon.png
// module id = opet
// module chunks = 1